import Storage from '@/helpers/storage'

export default {

    saveTracking: function (query) {

        const preferences = Storage.getItem(Storage.KEYS.COOKIE_LAW_PREFERENCES)

        if (preferences) {

            const preferencesObj = JSON.parse(preferences)

            if (preferencesObj) {

                const preferencesUtm = preferencesObj.filter(item => item.name === 'utm')

                if (preferencesUtm && preferencesUtm.active) {

                    const utmSource = getValue(query, 'utm_source') || 'organic'

                    Storage.setItem('utm_source', utmSource)

                    if (query.utm_campaign) {
                        Storage.setItem('utm_campaign', getValue(query, 'utm_campaign'))
                    }
                    if (query.utm_medium) {
                        Storage.setItem('utm_medium', getValue(query, 'utm_medium'))
                    }
                    if (query.cid) {
                        Storage.setItem('cid', getValue(query, 'cid'))
                    }
                    if (query.TDUID) {
                        Storage.setItem('TDUID', getValue(query, 'TDUID'))
                    }

                    Storage.setItem('referrer', getValue(query, 'fox_referrer') || document.referrer || document.referer)
                }
            }
        }

        if (query.token) {
            Storage.setItem('token', getValue(query, 'token'))
        }
    },

    getTracking: function () {

        const utms = {}

        const source = Storage.getItem('utm_source')
        const campaign = Storage.getItem('utm_campaign')
        const medium = Storage.getItem('utm_medium')
        const referrer = Storage.getItem('referrer')
        const cid = Storage.getItem('cid')

        if (source) {
            utms['utm_source'] = source
        }
        if (campaign) {
            utms['utm_campaign'] = campaign
        }
        if (medium) {
            utms['utm_medium'] = medium
        }
        if (referrer) {
            utms['referrer'] = referrer
        }
        if (cid) {
            utms['cid'] = cid
        }

        return utms
    },

    getTrackingToQuery: function () {

        const tracking = this.getTracking()

        let str = ''

        for (const proprety in tracking) {

            if (tracking[proprety] && tracking[proprety] !== 'undefined') {

                str = `${str}${str.length ? '&' : ''}${proprety}=${tracking[proprety]}`

            }

        }

        return str


    }
}

function getValue(obj, key) {

    let value = obj[key]

    if (Array.isArray(value)) {

        value = value[0]
    }

    return value
}
